import { render } from "./microphone.vue?vue&type=template&id=32838b59"
const script = {}

import exportComponent from "D:\\wamp\\www\\ycjx\\chat-example\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__